// extracted by mini-css-extract-plugin
module.exports = {"icon":"column-text_icon_3S1cv","text":"column-text_text_NqwJ1"};